import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiTrendingDown, FiActivity, FiDollarSign, FiPieChart } = FiIcons;

const FinancialSummaryCards = ({ transactions }) => {
  const income = transactions.filter(t => t.type === 'Income').reduce((s, t) => s + Number(t.amount), 0);
  const expenses = transactions.filter(t => t.type === 'Expense').reduce((s, t) => s + Number(t.amount), 0);
  const noi = income - expenses;
  const margin = income > 0 ? ((noi / income) * 100).toFixed(1) : 0;

  const cards = [
    { title: 'Gross Revenue', value: income, icon: FiTrendingUp, color: 'text-green-600', bg: 'bg-green-50' },
    { title: 'Operating Expenses', value: expenses, icon: FiTrendingDown, color: 'text-red-600', bg: 'bg-red-50' },
    { title: 'Net Operating Income', value: noi, icon: FiActivity, color: 'text-indigo-600', bg: 'bg-indigo-50' },
    { title: 'Operating Margin', value: `${margin}%`, icon: FiPieChart, color: 'text-purple-600', bg: 'bg-purple-50' }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map((card, i) => (
        <div key={i} className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-2xl ${card.bg} ${card.color}`}>
              <SafeIcon icon={card.icon} size={20} />
            </div>
            <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Real-time</span>
          </div>
          <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">{card.title}</p>
          <p className={`text-3xl font-black text-gray-900`}>
            {typeof card.value === 'number' ? `$${card.value.toLocaleString()}` : card.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default FinancialSummaryCards;